/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockUnits
 * @description data access service for managing stock units
 */
angular.module('mercury.modules.stock.unit')
.factory('StockUnits', ["$resource", "settings", function($resource, settings) {
  var StockUnits = $resource(settings.apiHost + '/r/StockUnits/:id', {id: '@id'});

  // New Stock API requests
  var Units = $resource(`${settings.stockHost}/internal/units/:id`, {id: '@id'});

  /**
   * Get a summary list of all stock units
   *
   * @memberof StockUnits
   */
  function getAllActive() {
    return StockUnits.query({$filter: 'DatestampDeleted eq null'});
  }

  /**
   * Get a list of all stock units via the Stock API
   *
   * @memberof StockUnits
   */
    function getAllStockApi(includeDeleted) {
      // Angular is not using ES6 so not allowed to use default parameters
      includeDeleted = includeDeleted ? includeDeleted : false
      return Units.query({includeDeleted});
    }

  /**
   * Get a summary list of all custom stock units
   *
   * @memberof StockUnits
   */
  function getAllManage() {
    return StockUnits.query({$filter: 'MasterId eq null'});
  }

  /**
   * create a new stock unit
   *
   * @memberof StockUnits
   * @param  {Object} unit New unit model
   */
  function create(unit) {
    return StockUnits.save(unit).$promise;
  }

  /**
   * Set the specified unit as deleted
   *
   * @memberof StockUnits
   * @param  {Object} unit model of the unit to delete
   */
  function remove(unit) {
    var unitToDelete = angular.copy(unit);
    unitToDelete.datestampDeleted = moment().format();
    return StockUnits.update(unitToDelete).$promise;
  }

  /**
   * Set the specified unit as not deleted
   *
   * @memberof StockUnits
   * @param  {Object} unit model of the unit to set as not deleted
   */
  function restore(unit) {
    var unitToRestore = angular.copy(unit);
    unitToRestore.datestampDeleted = null;
    return StockUnits.update(unitToRestore).$promise;
  }

  return {
    getAllActive: getAllActive,
    getAllStockApi,
    getAllManage: getAllManage,
    create: create,
    remove: remove,
    restore: restore
  };
}]);
